<template>
  <div>
    <div v-if="showScrollButtons" class="hpScrollBox">
      <button @click="scrollToTop">
        <img
          :src="require(`@/assets/images/icon/top_scroll.png`)"
          alt="화살표"/>
      </button>
      <!-- <button @click="scrollToBottom">
        <img
          :src="require(`@/assets/images/icon/down_scroll.png`)"
          alt="화살표"/>
      </button> -->

      <div class="hpScrollInfo">
        <a class="hpScrollInfo_kakao" href="https://pf.kakao.com/_Sbexmxj" target="_blank"></a>
        <a class="hpScrollInfo_insta" href="https://www.instagram.com/nforu_official/" target="_blank"></a>
        <a class="hpScrollInfo_call" href="tel:051-743-6147"></a>
      </div>
    </div>
  </div>
</template>

<script>
import { ref } from 'vue'

export default {
  methods: {
    scrollToTop () {
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      })
    },
    scrollToBottom () {
      window.scrollTo({
        top: document.body.scrollHeight,
        behavior: 'smooth'
      })
    }
  },
  setup () {
    const showScrollButtons = ref(true)

    const scrollToTop = () => {
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      })
    }

    const scrollToBottom = () => {
      window.scrollTo({
        top: document.body.scrollHeight,
        behavior: 'smooth'
      })
    }

    return {
      showScrollButtons,
      scrollToTop,
      scrollToBottom
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Homepage/Section/Scroll.vue